var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoGraduacion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2393 4324 c-23 -8 -491 -275 -1040 -594 -721 -419 -1003 -587 -1015 -607 -29 -46 -23 -98 14 -137 30 -31 1822 -1080 1991 -1165 87 -45 200 -54 287 -24 77 26 2007 1147 2048 1189 23 25 32 43 32 68 0 45 -17 82 -47 101 -107 70 -1992 1157 -2028 1169 -57 20 -186 20 -242 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4538 2618 l-138 -81 0 -524 0 -524 -29 -25 c-17 -14 -42 -50 -57 -80 -23 -48 -26 -63 -22 -124 19 -263 357 -331 481 -96 34 65 31 165 -8 235 -16 29 -40 60 -52 68 l-23 15 0 609 c0 335 -3 609 -7 608 -5 0 -70 -37 -145 -81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042 1954 l3 -349 32 -65 c18 -36 51 -84 75 -107 41 -39 759 -463 938 -553 149 -75 305 -107 479 -97 133 7 241 35 356 91 170 82 908 515 953 559 24 23 57 71 75 107 l32 65 3 348 3 348 -23 -14 c-87 -56 -1145 -666 -1194 -689 -155 -73 -354 -75 -507 -5 -43 20 -1132 648 -1205 695 l-23 15 3 -349z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGraduacion);
export default __webpack_public_path__ + "static/media/logo-graduacion.cfc01daa37d2c9e0f9a22890e149ba14.svg";
export { ForwardRef as ReactComponent };